import { RedirectApp } from '@/enums/RedirectApp';
import { AUTH_CODE, REDIRECT_APP, REDIRECT_PATH } from '@/constants/authentication';

/**
 * Get the redirect app URL from environment variables based on the redirect app type
 */
export const getRedirectAppUrl = (redirectApp: string | null): string => {
  switch (redirectApp) {
    case RedirectApp.COMPANY:
      return import.meta.env.VITE_COMPANY_APP_URL || '';
    case RedirectApp.CANDIDATE:
      return import.meta.env.VITE_CANDIDATE_APP_URL || '';
    case RedirectApp.ADMIN:
      return import.meta.env.VITE_ADMIN_APP_URL || '';
    default:
      return import.meta.env.VITE_CANDIDATE_APP_URL || '';
  }
};

/**
 * Performs client-side redirect to the appropriate app with auth code
 */
export const performRedirect = (params: {
  redirectApp?: string | null;
  redirectPath?: string | null;
  authCode?: string | null;
}) => {
  const redirectAppUrl = getRedirectAppUrl(params.redirectApp || null);
  const authCode = params.authCode;

  if (redirectAppUrl && authCode) {
    const redirectPath = params.redirectPath || '';

    // Combine redirect app url with redirect_path to enable going to specific page.
    // Add authCode to enable authorization on the redirected app.
    const separator = redirectPath?.includes('?') ? '&' : '?';
    const isCandidateApp = !params.redirectApp || params.redirectApp === RedirectApp.CANDIDATE;
    const lngParam = isCandidateApp
      ? `&lng=${localStorage.getItem('language') || window.location.pathname.split('/')[1] || 'en'}`
      : '';
    const redirectUrl =
      redirectAppUrl +
      redirectPath +
      `${separator}authCode=${authCode}${lngParam}`;

    window.location.href = redirectUrl;
  } else {
    // Fallback to login if missing required params
    const currentLang = window.location.pathname.split('/')[1] || 'en';
    const loginUrl = `/${currentLang}/sign-in${params.redirectApp ? `?${REDIRECT_APP}=${params.redirectApp}` : ''}`;
    window.location.href = loginUrl;
  }
};
